'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
cbStripHeroHomepageV1.$inject = ['$window', '$timeout', 'ApiService'];

var _module = angular.module('cb.strips.cbStripHeroHomepageV1', []);

_module.directive('cbStripHeroHomepageV1', cbStripHeroHomepageV1);

exports.default = _module;


function cbStripHeroHomepageV1($window, $timeout, ApiService) {
    return {
        restrict: 'A',
        link: cbStripHeroHomepageV1Link
    };

    function cbStripHeroHomepageV1Link(scope, element, attr) {
        addHeroHomepageCbFunctions(element);
    }

    function addHeroHomepageCbFunctions(element) {
        var _gettersAndSetters = addHeroHomepageGettersAndSetters(element);
        var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

        ApiService.attach({
            'hero-homepage': gettersAndSetters
        });
    }

    function addHeroHomepageGettersAndSetters(element) {
        var hero = {};

        Object.defineProperty(hero, 'title', {
            get: function get() {
                return element.find('.heading-page-title').html();
            },
            set: function set(newValue) {
                element.find('.heading-page-title').html(newValue);
            }
        });

        Object.defineProperty(hero, 'subtitle', {
            get: function get() {
                return angular.element(element.find('.heading-page-subtitle')[0]).html();
            },
            set: function set(newValue) {
                angular.element(element.find('.heading-page-subtitle')[0]).html(newValue);
            }
        });

        Object.defineProperty(hero, 'image', {
            get: function get() {
                return $('.hero__image').css('background-image');
            },
            set: function set(newValue) {
                $('.hero__image').css('background-image', 'url("' + newValue + '")');
            }
        });

        Object.defineProperty(hero, 'imageAlt', {
            get: function get() {
                return $('.hero__image').attr('title');
            },
            set: function set(newValue) {
                $('.hero__image').attr('title', newValue);
            }
        });

        Object.defineProperty(hero, 'button', {
            get: function get() {
                return element.find('.btn--primary').html();
            },
            set: function set(newValue) {
                element.find('.btn--primary').html(newValue);
            }
        });

        Object.defineProperty(hero, 'buttonAlt', {
            get: function get() {
                return $('.btn--primary').attr('title');
            },
            set: function set(newValue) {
                $('.btn--primary').attr('title', newValue);
            }
        });

        Object.defineProperty(hero, 'href', {
            get: function get() {
                return element.find('.btn--primary').attr('href');
            },
            set: function set(newValue) {
                element.find('.btn--primary').attr('href', newValue);
            }
        });

        /*
        cb('hero-homepage','set', {
            'calamiteiten-banner': {
                id:       'storm-A1',
                styling:  'major',
                icon:     'warning',
                title:    'Schaatsen uit het vet?',
                text:     'Op natuurijs schaatsen zit er waarschijnlijk niet in. Maar het gaat de komende dagen wel vriezen. Wat is handig bij bevriezing en gladheid op de weg?',
                cta:      'Lees onze tips',
                link:     'https://www.centraalbeheer.nl/magazine/paginas/magazine.aspx/in-het-verkeer/tips-bevriezing-gladheid'
            }
        });
        */

        Object.defineProperty(hero, 'calamiteiten-banner', {
            get: function get() {
                return element.find('.calamiteiten-banner__wrapper');
            },
            set: function set(newValue) {
                var compile = angular.element(document.body).injector().get('$compile');
                var scope = angular.element(document.body).injector().get('$rootScope');
                var calamiteitenBanner = document.createElement('cb-calamiteiten-banner');

                element[0].insertAdjacentElement('afterend', calamiteitenBanner);

                var banner = angular.element('cb-calamiteiten-banner');

                var allowedAttributes = ['id', 'styling', 'icon', 'title', 'text', 'link', 'cta'];
                allowedAttributes.forEach(function (attr) {
                    if (newValue[attr] !== undefined) {
                        banner.attr(attr, newValue[attr]);
                    }
                });

                compile(banner)(scope);
            }
        });

        return hero;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/hero-homepage-v1/hero-homepage.directive.js
// module id = 945
// module chunks = 1